import { render, staticRenderFns } from "./Microprotocols.vue?vue&type=template&id=7c494418&scoped=true&"
import script from "./Microprotocols.vue?vue&type=script&lang=js&"
export * from "./Microprotocols.vue?vue&type=script&lang=js&"
import style0 from "./Microprotocols.vue?vue&type=style&index=0&id=7c494418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c494418",
  null
  
)

export default component.exports